exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download-btn[data-v-39648e34] {\n  color: #2b93ff !important;\n  margin-top: 10px;\n  display: block;\n  font-size: 12px;\n}\n[data-v-39648e34] .error-body div {\n  margin: 0;\n  margin-top: 20px;\n  padding: 10px;\n}\n.warehouse-row[data-v-39648e34] {\n  cursor: pointer;\n}\n.warehouses-dashboard[data-v-39648e34]  .md-card {\n  margin-bottom: 0;\n}\n.is-default-icon[data-v-39648e34] {\n  padding-left: 20px;\n  color: green !important;\n}\n[data-v-39648e34] .header-button {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  margin-top: 0;\n}\n", ""]);

// exports
